module.exports = __webpack_public_path__ + "img/0489C5_0DDDF9_04C3EE_04AFE1-256px.5aff2442.png";